export const vars = {
  revalidatePeriod: 3600 * 24,
  pxPerRem: 16,
  mobileBreakpointPx: 768,
  dekoratorenHeight: 104,
};
